import React from 'react';

import cn from 'classnames';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import styles from './UserAvatar.module.scss';

/**
 * UserAvatar component
 * @param {string} background - Background color: 'default', 'primary', 'secondary', 'neutral', or 'gradient'
 */
export const UserAvatar = ({
  children,
  className,
  tooltip,
  background = 'default',
  placement = 'top',
  onClick = () => {},
}) => (
  <OverlayTrigger
    trigger={tooltip ? ['hover', 'focus'] : 'none'}
    placement={placement}
    overlay={<Tooltip>{tooltip}</Tooltip>}>
    <div
      className={cn(styles.root, {
        [className]: className,
        [styles[background]]: styles[background],
      })}
      onClick={onClick}>
      {children}
    </div>
  </OverlayTrigger>
);
